import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { memo } from "react";
import { LayoutChrome } from "./LayoutChrome.js";
import { useClassNamePrefix } from "../../auxiliary/useClassNamePrefix.js";
const Layout = memo(({
  className,
  children,
  sidebarHeader,
  sidebarFooter,
  switchers,
  navigation,
  scheme,
  theme,
  themeContent,
  themeControls,
  pageScheme,
  pageTheme,
  pageThemeContent,
  pageThemeControls,
  titleScheme,
  titleTheme,
  titleThemeContent,
  titleThemeControls
}) => {
  const prefix = useClassNamePrefix();
  const classList = classNames(
    `${prefix}layout`,
    className
  );
  return /* @__PURE__ */ jsx("div", { className: classList, children: /* @__PURE__ */ jsx(
    LayoutChrome,
    {
      sidebarHeader,
      sidebarFooter,
      navigation,
      switchers,
      scheme,
      theme,
      themeContent,
      themeControls,
      pageScheme,
      pageTheme,
      pageThemeContent,
      pageThemeControls,
      titleScheme,
      titleTheme,
      titleThemeContent,
      titleThemeControls,
      children
    }
  ) });
});
export {
  Layout
};
//# sourceMappingURL=Layout.js.map
